module.exports = __webpack_public_path__ + "img/tittle1.dd5cf49b.png";